// extracted by mini-css-extract-plugin
export default {"root":"TopicTools_root__tqkAv","segment":"TopicTools_segment__5Vo9n"};